var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleSystemGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "people-system-guide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0005 0.2973 46.9725 0.2973 46.9725 43 0.0005 43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.3507 0.891 17.4327 0.891 17.4327 45.6327 0.3507 45.6327"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-system-guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(22.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 9.109400)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8375,0.2973 L38.4325,0.2973 L38.4325,4.6633 L42.7025,4.5683 L42.7025,32.3243 L32.0265,32.3243 C29.7115,32.3273 27.4615,33.0913 25.6215,34.4963 L25.6215,34.4973 C25.6215,35.6763 24.6655,36.6323 23.4865,36.6323 C22.3075,36.6323 21.3515,35.6763 21.3515,34.4973 L21.3515,34.4963 C19.5115,33.0913 17.2615,32.3283 14.9455,32.3243 L4.2705,32.3243 L4.2705,4.5683 L14.9455,4.5683 C18.4835,4.5683 21.3515,7.4363 21.3515,10.9733 L21.3515,2.8333 C21.3515,2.5673 21.3785,2.3323 21.3885,2.0783 C21.3735,2.1953 21.3515,2.3083 21.3515,2.4333 L21.3515,2.4853 C19.5135,1.0733 17.2635,0.3053 14.9455,0.2973 L2.1355,0.2973 C0.9565,0.2973 0.0005,1.2533 0.0005,2.4333 L0.0005,34.4593 C0.0005,35.6393 0.9565,36.5943 2.1355,36.5943 L14.9455,36.5943 C17.8555,36.6093 20.3895,38.5813 21.1165,41.3993 C21.3595,42.3413 22.2095,42.9993 23.1825,43.0003 L23.7905,43.0003 C24.7635,42.9993 25.6125,42.3413 25.8565,41.3993 C26.5835,38.5813 29.1175,36.6093 32.0265,36.5943 L44.8375,36.5943 C46.0165,36.5943 46.9725,35.6393 46.9725,34.4593 L46.9725,2.4333 C46.9725,1.2533 46.0165,0.2973 44.8375,0.2973",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(21.000000, 0.109400)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1617,32.7007 C10.8637,32.6807 7.3877,33.0337 4.6217,34.8707 L4.6217,11.8337 C4.6217,7.5187 5.8687,5.5067 13.1617,5.2017 L13.1617,32.7007 Z M15.2967,0.8907 C8.2567,0.8907 0.7797,1.7187 0.3887,11.0787 C0.3777,11.3327 0.3507,11.5667 0.3507,11.8337 L0.3507,19.9727 L0.3507,43.4967 L0.3507,43.4977 C0.3507,44.6767 1.3077,45.6327 2.4867,45.6327 C3.6657,45.6327 4.6217,44.6767 4.6217,43.4977 L4.6217,43.4967 C4.6217,41.4217 5.2147,39.8987 6.4357,38.8427 C8.8717,36.7347 13.4337,36.8587 14.9797,37.0837 C15.5967,37.1757 16.2197,36.9957 16.6907,36.5907 C17.1617,36.1847 17.4327,35.5937 17.4327,34.9717 L17.4327,13.6637 L17.4327,9.2977 L17.4327,3.0257 C17.4327,1.8467 16.4757,0.8907 15.2967,0.8907 L15.2967,0.8907 Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.6851,36.0493 L15.4981,36.0493",
    id: "Stroke-7",
    stroke: "#FCBC00",
    strokeWidth: 2.299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4151,25.7505 L13.8221,25.7505",
    id: "Stroke-9",
    stroke: "#FCBC00",
    strokeWidth: 2.299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8219,26.7026 L12.0919,35.0796",
    id: "Stroke-11",
    stroke: "#FCBC00",
    strokeWidth: 4.233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0919,20.0376 C12.0919,18.7156 13.1639,17.6416 14.4869,17.6416 C15.8099,17.6416 16.8829,18.7156 16.8829,20.0376 C16.8829,21.3606 15.8099,22.4336 14.4869,22.4336 C13.1639,22.4336 12.0919,21.3606 12.0919,20.0376",
    id: "Fill-13",
    fill: "#FCBC00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleSystemGuide);
export default __webpack_public_path__ + "static/media/people-system-guide.4a74bbcc614f3589b2bdb728d828727f.svg";
export { ForwardRef as ReactComponent };